import { render, staticRenderFns } from "./TenantSettings.vue?vue&type=template&id=056a99e6&scoped=true"
import script from "./TenantSettings.vue?vue&type=script&lang=js"
export * from "./TenantSettings.vue?vue&type=script&lang=js"
import style0 from "./TenantSettings.vue?vue&type=style&index=0&id=056a99e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056a99e6",
  null
  
)

export default component.exports